import CopyableField from '@src/components/atoms/copiableField';

export default function GovActionMetadataCopiableDescriptionField({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <div className="flex w-full flex-col gap-1">
      <p className="body16 font-semibold dark:text-white">{label}</p>
      <CopyableField
        value={value}
        className="gap-2"
        iconClassName="!h-[18px] !w-[18px]"
        textOnly
        textClassName="body14 text-gray-400 max-w-[210px] sm:max-w-[300px] xl:max-w-[500px]"
      />
    </div>
  );
}
